import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { uerSetWorkOrderChangeLastSeasonGql } from '../../WorkOrderChangeQueries';

interface IUseUerSetWorkOrderChangeLastSeason {
    workOrderChangeId?: number;
    onSuccess?: () => void;
}

const requestId = 'uerSetWorkOrderChangeLastSeason';

export const useUerSetWorkOrderChangeLastSeason = (props: IUseUerSetWorkOrderChangeLastSeason) => {
    const dispatch = useDispatch();

    const { workOrderChangeId, onSuccess } = props;

    const [uerSetWorkOrderChangeLastSeasonReset] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(() => {
        uerSetWorkOrderChangeLastSeasonReset(undefined);
        onSuccess?.();
    }, [uerSetWorkOrderChangeLastSeasonReset, onSuccess]);

    const [, uerSetWorkOrderChangeLastSeasonStatus, , uerSetWorkOrderChangeLastSeasonRequest] = useRequest({
        requestId,
        query: uerSetWorkOrderChangeLastSeasonGql,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
    });

    const uerSetWorkOrderChangeLastSeasonMakeRequest = useCallback(
        (contractSeasonId: number) => {
            dispatch(uerSetWorkOrderChangeLastSeasonRequest({ workOrderChangeId, contractSeasonId }));
        },
        [dispatch, uerSetWorkOrderChangeLastSeasonRequest, workOrderChangeId],
    );

    useEffect(() => {
        uerSetWorkOrderChangeLastSeasonReset(undefined);
    }, [uerSetWorkOrderChangeLastSeasonReset]);

    return {
        uerSetWorkOrderChangeLastSeasonStatus,
        uerSetWorkOrderChangeLastSeasonMakeRequest,
    };
};
